import React from 'react';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { Stack, Box } from '@atlaskit/primitives/compiled';
import { ContentMetricsTable } from './ContentMetricsTable.tsx';
import { mockContentMetrics } from '../__fixtures__/performanceInsightsMockData.ts';

const styles = cssMap({
	container: {
		width: '100%',
		marginBlockStart: token('space.300'),
	},
	tableSection: {
		marginTop: token('space.600'),
	},
});

type ContentMetricsTabProps = {
	// TODO: Add props as needed
};

export const ContentMetricsTab = (_props: ContentMetricsTabProps) => {
	return (
		<>
			<Stack xcss={styles.container}>
				{/* TODO: Add filters or other header components */}
				<Box xcss={styles.tableSection}>
					<ContentMetricsTable items={mockContentMetrics} />
				</Box>
			</Stack>
		</>
	);
};
